import { gql } from 'graphql-request';
import { fragmentCoding, fragmentReference } from '../fragments';

// gql-tagged (not a plain string) so graphql-codegen plucks `fragment Procedure` and can resolve
// `...Procedure` in the query. The `...Coding` / `...Reference` references resolve against the
// separately-plucked `fragmentCoding` / `fragmentReference`. At runtime `gql` is an identity tag,
// so interpolation is unchanged.
export const fragmentProcedure = gql`
  ${fragmentCoding}
  ${fragmentReference}

  fragment Procedure on Procedure {
    id
    resourceType
    meta {
      tag {
        system
        code
      }
      extension {
        url
        valueReference {
          reference
        }
      }
    }
    status
    code {
      text
      coding {
        ...Coding
      }
    }
    category {
      text
      coding {
        ...Coding
      }
    }
    performedDateTime
    performedPeriod {
      start
      end
    }
    performedString
    performedAge {
      value
      unit
    }
    performedRange {
      low {
        value
        unit
      }
      high {
        value
        unit
      }
    }
    performer {
      actor {
        display
      }
      function {
        text
        coding {
          ...Coding
        }
      }
    }
    bodySite {
      text
      coding {
        ...Coding
      }
    }
    reasonCode {
      text
      coding {
        ...Coding
      }
    }
    outcome {
      text
      coding {
        ...Coding
      }
    }
    ProvenanceList(_reference: "target") {
      id
      target {
        reference
      }
      entity {
        role
        what {
          ...Reference
        }
      }
    }
  }
`;
